import React from "react";

import { generateMediaUrl } from "../../../helpers/media";
import Link from "../../../components/Link";
import Title from "../../../components/Title";

import style from "./style.module.css";

export default function LogoList({item = [], title = ""}) {
    return (
        <div className={style.footerThanksColumn}>
            {
                title !== "" && (
                    <Title className="size14" tag="p">{title}</Title>
                )
            }
            {
                item.length > 0 && (
                    <div className={style.logoList}>
                        {
                            item.map((logo, logoIndex) => {
                                return (
                                    <Link key={`logoIndex_${logoIndex}`} to={logo.url} className={style.logoItem}>
                                        <img alt="brandLogo" src={generateMediaUrl(logo.background, "0x35")} className={style.brandLogo} />
                                    </Link>
                                )
                            })
                        }
                    </div>
                )
            }
        </div>
    )
}